import { useCallback, useMemo } from 'react'
import { Dialog, DialogContent, DialogTitle, makeStyles, IconButton, Icon } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { FONT_WEIGHTS } from '../../../../../utils'
import { purple } from '@material-ui/core/colors'
import useGroomingVisit from '../../../../../hooks/useGroomingVisit'
import moment from 'moment'

const useStyles = makeStyles(() => ({
	content: { display: 'flex', flexDirection: 'column', gap: '.6rem' },
	header: {
		display: 'flex',
		marginBottom: '.8rem',
		justifyContent: 'flex-end',
		gap: '.4rem',
		'& div:nth-child(2)': {
			flex: 1
		}
	},
	infoIconContainer: {
		display: 'flex'
	},
	infoIcon: {
		color: purple[500],
		fontSize: '1.18rem',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		overflow: 'unset'
	},
	titleText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem',
		textTransform: 'uppercase'
	},
	headerText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem'
	},
	policyText: {
		fontFamily: 'Nunito',
		fontSize: '1rem'
	}
}))

const CancellationPolicyDialog = ({ open, onClose }) => {
	const classes = useStyles()

	const { facility } = useGroomingVisit()

	const text = useMemo(() => {
		if (facility) {
			const services = facility.services['grooming']
			const end_time = moment(services.free_period_end_time, 'HH:mm').format('h:mm a')
			const end_date = services.free_period_end_date_text?.toLowerCase()
			const mid_time = moment(services.mid_period_end_time, 'HH:mm').format('h:mm a')
			const mid_date = services.mid_period_end_date_text?.toLowerCase()
			let grooming_fee_one = services.mid_period_fee_type?.toLowerCase().includes('percent')
				? `${services.mid_period_base_fee_percent}% of your base service cost`
				: fee_one
			let grooming_fee_two = services.final_period_fee_type?.toLowerCase().includes('percent')
				? `${services.final_period_base_fee_percent}% of your base service cost`
				: full_fee

			return `Cancellations made after ${end_time} ${end_date} the appointment but before ${mid_time} ${mid_date} the appointment will incur a fee of $${grooming_fee_one}. Cancellations made after ${mid_time} ${mid_date} the appointment or no-shows will incur a fee of $${grooming_fee_two}.`
		}
	}, [facility])

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	return (
		<Dialog
			PaperProps={{
				style: {
					width: 400,
					maxWidth: 400,
					maxHeight: 400,
					minWidth: 400
				}
			}}
			maxWidth="md"
			open={open}
			onClose={handleOnClose}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.infoIconContainer}>
						<Icon className={`fas fa-info-circle ${classes.infoIcon}`} />
					</div>
					<div className={classes.titleText}>Cancellation Policy</div>
					<IconButton disableRipple style={{ padding: 0, flex: 0 }}>
						<Close onClick={handleOnClose} />
					</IconButton>
				</div>
			</DialogTitle>
			<DialogContent className={classes.content}>
				<div>{text}</div>
			</DialogContent>
		</Dialog>
	)
}

export default CancellationPolicyDialog
